import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { SearchX, Home, Briefcase, Building2 } from "lucide-react";
const NotFound = () => {
  const location = useLocation();
  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);
  return <div className="min-h-screen flex flex-col bg-background">
      <Header />
      
      <main className="flex-1 flex items-center justify-center">
        <section className="bg-gradient-to-br from-primary/10 via-background to-accent/10 w-full py-16 md:py-[20px]">
          <div className="container mx-auto px-4">
            <div className="max-w-2xl mx-auto text-center">
              {/* Ícone */}
              <div className="mb-6">
                <SearchX className="w-20 h-20 md:w-24 md:h-24 text-muted-foreground/50 mx-auto" />
              </div>
              
              {/* Número 404 estilizado */}
              <h1 className="text-7xl md:text-9xl font-bold mb-4 font-display">
                <span className="text-accent">4</span>
                <span className="text-primary">0</span>
                <span className="text-accent">4</span>
              </h1>
              
              {/* Título */}
              <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-4 font-display">
                Página não encontrada
              </h2>
              
              {/* Descrição */}
              <p className="text-base md:text-lg text-muted-foreground mb-8 max-w-md mx-auto">
                Ops! A página que você está procurando não existe ou foi movida.
              </p>
              
              {/* Botão principal */}
              <Button size="lg" asChild className="mb-8">
                <Link to="/">
                  <Home className="w-4 h-4 mr-2" />
                  Voltar para a página inicial
                </Link>
              </Button>
              
              {/* Links úteis */}
              <div className="pt-8 border-t border-border py-0">
                <p className="text-sm text-muted-foreground mb-4">
                  Ou navegue para uma dessas páginas:
                </p>
                <div className="flex flex-wrap justify-center gap-6">
                  <Link to="/vagas" className="flex items-center gap-2 text-primary hover:text-primary/80 hover:underline transition-colors">
                    <Briefcase className="w-4 h-4" />
                    Buscar Vagas
                  </Link>
                  <Link to="/empresas" className="flex items-center gap-2 text-primary hover:text-primary/80 hover:underline transition-colors">
                    <Building2 className="w-4 h-4" />
                    Ver Empresas
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>;
};
export default NotFound;